// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RemoveSignerModal_wrapper__1_1me","animation":"RemoveSignerModal_animation__owK1L","text":"RemoveSignerModal_text__30mvq"};